var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8 7V8.99922H8.2V7C8.2 4.90132 9.90132 3.2 12 3.2C14.0987 3.2 15.8 4.90132 15.8 7ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7V9C18.6569 9 20 10.3431 20 12V18C20 19.6569 18.6569 21 17 21H7C5.34315 21 4 19.6569 4 18V12C4 10.3431 5.34315 9 7 9V7ZM12.6 15.2395C12.9587 15.032 13.2 14.6442 13.2 14.2C13.2 13.5373 12.6627 13 12 13C11.3373 13 10.8 13.5373 10.8 14.2C10.8 14.6442 11.0413 15.032 11.4 15.2395V17C11.4 17.3314 11.6686 17.6 12 17.6C12.3314 17.6 12.6 17.3314 12.6 17V15.2395Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.1ee5dd701c08248bb5057074e0137374.svg";
export { ForwardRef as ReactComponent };